'use client';

import React, { useEffect, useRef, useState } from 'react';
import * as Sentry from '@sentry/nextjs';
import { BugOutlined } from '@ant-design/icons';
import cn from 'classnames';
import Cookies from 'js-cookie';
import styles from './report-bug-button.module.css';

type FeedbackType = ReturnType<typeof Sentry.getFeedback>;

const ReportBugButton: React.FC = () => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [feedback, setFeedback] = useState<FeedbackType | undefined>();
    const [feedbackReady, setFeedbackReady] = useState(false);

    useEffect(() => {
        const userName = Cookies.get('fullName');
        const userEmail = Cookies.get('email');

        if (userName || userEmail) {
            Sentry.setUser({
                name: userName,
                email: userEmail,
            });
        }
        setFeedback(Sentry.getFeedback());
    }, []);

    useEffect(() => {
        if (feedback && buttonRef.current) {
            setFeedbackReady(true);
            const unsubscribe = feedback.attachTo(buttonRef.current);
            return unsubscribe;
        }
    }, [feedback]);

    return (
        <div
            className={cn(
                'feedback-bug-container fixed bottom-6 right-[-32px] z-50 hover:right-[6px] transition-all duration-300',
            )}
        >
            <button
                ref={buttonRef}
                id="sentry-feedback-button"
                disabled={!feedbackReady}
                className={cn(
                    styles.component,
                    'w-12 h-12 flex items-center justify-center bg-red-200 text-white rounded-full shadow-lg hover:bg-red-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed',
                )}
                title="Сообщить об ошибке"
            >
                <BugOutlined className="text-2xl" />
            </button>
        </div>
    );
};

export default ReportBugButton;
